import { z } from 'zod';

const status = z.enum(['ok', 'partial', 'permission_required', 'error']);
const count = z.number().int().nonnegative().safe().nullable();
const amount = z.string().regex(/^-?\d+\.\d{2}$/).nullable();
export const smsFinanceSnapshotSchema = z.object({
  fetchedAt: z.iso.datetime(),
  packages: z.object({ status, total: count, used: count, remaining: count, expiresAt: z.iso.datetime().nullable(), note: z.string() }).strict(),
  account: z.object({ status, available: amount, cash: amount, currency: z.literal('CNY'), note: z.string() }).strict(),
}).strict();
export const smsFinanceOverviewSchema = z.object({ items: z.array(z.object({
  configId: z.uuid(), revision: z.number().int().positive(), name: z.string(), snapshot: smsFinanceSnapshotSchema.nullable(),
}).strict()) }).strict();
export type SmsFinanceOverview = z.infer<typeof smsFinanceOverviewSchema>;
